import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const TriangleIcon = ({
  width = "10",
  height = "5",
  color = "black",
  rotate,
  opacity,
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} rotate={rotate}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 10 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path opacity={opacity} d="M0 0L5 5L10 0H0Z" fill={color} />
      </svg>
    </IconWrapper>
  );
};
